module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/out-avatar-33cde4f3e9efcc111cd84ddf97d9dfe3.png";